import { allPlugins } from './Fct';
import { getMulticallPluginConstructor } from './Fct/Fct.multicall';
var getPlugin = function (_a) {
    var signature = _a.signature, address = _a.address, chainId = _a.chainId;
    var plugins = allPlugins.filter(function (plugin) {
        var pluginInstance = new plugin.plugin({ chainId: chainId });
        return pluginInstance.methodInterfaceHash === signature;
    });
    if (plugins.length === 1) {
        return plugins[0];
    }
    if (plugins.length > 1) {
        var plugin = plugins.find(function (plugin) {
            var pluginInstance = new plugin.plugin({ chainId: chainId });
            if (pluginInstance.supportedContracts.length !== 0) {
                return (pluginInstance.supportedContracts.findIndex(function (contract) {
                    return contract.address.toLowerCase() === address.toLowerCase() && contract.chainId === Number(chainId);
                }) !== -1);
            }
            return false;
        });
        // if plugin is matched, return single plugin.
        // else there are multiple matches for the provided function parameters - instead of 
        // throwing an error, return the list of plugins (required in core library)
        return plugin !== null && plugin !== void 0 ? plugin : plugins;
    }
    var mCallPlugin = getMulticallPluginConstructor({ signature: signature, chainId: chainId });
    return { plugin: mCallPlugin, name: mCallPlugin === null || mCallPlugin === void 0 ? void 0 : mCallPlugin.name };
};
export * from './Fct';
export * from './Fct/Fct.multicall';
export { getPlugin };
